export const getDgiTaxes = (state) => state.dgiTaxes
